__turbopack_context__.v({
  "offerElement": "OffersCarousel-module__UzNKzq__offerElement",
  "root": "OffersCarousel-module__UzNKzq__root",
});
